<template lang="pug">
#modal-consolidar-lote-pssc
    el-dialog(
        :title="$t('mensagens.pssc.telaIncluirTerritorios.incluirTerritorios')",
        :width='width',
        :visible.sync='show_',
        :close-on-click-modal='false',
        :destroy-on-close='true',
        :show-close='false',
        custom-class='no-box-shadow',
        show-close,
        @close='closeDialog()'
    )

        div.modal-sucesso-content(style='display: flex; flex-direction: column')
            .modal-selecao-sucesso-container
                i.el-icon.icon-success-filled-verde(
                    class='el-icon-success'
                )
                p.sucesso-selecao-descricao
                    | {{ $t('mensagens.pssc.telaIncluirTerritorios.territoriosSelecionados') }}

            .modal-lote-container
                div.modal-texto-bold {{ $t('mensagens.pssc.telaIncluirTerritorios.escolhaComoProsseguir') }}
                div.modal-selecao-lote
                    el-radio.selecao-lote(
                        v-model='modoSelecaoLote',
                        :disabled='!opcoesLotes',
                        label='ESCOLHER_LOTE',
                        @change='alterarMetodoConsolidacao'
                    ) {{ $t('mensagens.pssc.telaIncluirTerritorios.escolherLoteExistente') }}
                    el-radio.selecao-lote(
                        v-model='modoSelecaoLote',
                        label='NOVO_LOTE',
                        @change='alterarMetodoConsolidacao'
                    ) {{ $t('mensagens.pssc.telaIncluirTerritorios.criarNovoLote') }}

            .modal-escolha-lote(v-if='modoSelecaoLote==="ESCOLHER_LOTE"')
                div {{ $t('mensagens.pssc.telaIncluirTerritorios.escolhaUmLote') }}
                el-select.el-select_lote(
                    v-model='lote',
                    :loading='loading.lote',
                    @change='habilitarConsolidarLote',
                    clearable,
                    filterable
                )
                    el-option(
                        v-for='{ nome, id } in opcoesLotes',
                        :key='id + nome',
                        :label='nome',
                        :value='id'
                    )
                div.cadastro-campo-erro(v-if='lote===""') {{ $t('mensagens.comuns.campoObrigatorio') }}

            .modal-novo-lote(v-else)
                div {{ $t('mensagens.pssc.telaIncluirTerritorios.nomeParaNovoLote') }}
                el-input.el-input_lote(
                    :placeholder="$t('mensagens.pssc.telaIncluirTerritorios.placeholderNovoLote')",
                    v-model='nomeNovoLote',
                    @input='habilitarConsolidarLote',
                    clearable,
                    show-word-limit,
                    maxlength="50"
                )
                div.cadastro-campo-erro(v-if='nomeNovoLote===""') {{ $t('mensagens.comuns.campoObrigatorio') }}
                div.cadastro-campo-erro(v-if='mostrarMensagemErroLote')
                    i.el-icon-info {{ $t('mensagens.pssc.telaIncluirTerritorios.erroInserirLoteExistente') }}

        .dialog-footer(slot='footer')
            el-button.outline-button(
                type='outline',
                size='mini',
                @click='closeDialog'
            ) {{ $t('mensagens.comuns.cancelar') }}
            el-button.primary-button(
                type='primary',
                size='mini',
                :disabled='habilitarConsolidar',
                @click='processarNovoLote'
            ) {{ $t('mensagens.pssc.telaIncluirTerritorios.consolidarLote') }}
</template>

<script>
import PSSCService from '@/services/PSSCService';

export default {
    name: 'ModalConsolidarLote',
    emits: ['showNotificacaoSucesso'],
    components: { },

    props: {
        show: {
            type: Boolean,
            default: false,
            required: true
        },
        selecionarTodos: {
            type: Boolean,
            required: true
        },
        selecao: {
            type: Array,
            required: true
        },
        filtros: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            carregando: false,
            mostrarMensagemErroLote: false,
            modoSelecaoLote: 'NOVO_LOTE',
            lote: null,
            nomeNovoLote: null,
            loading: {
                lote: null
            },
            opcoesLotes: null,

            show_: false,
            nomeNovoLote_: null,
            habilitarConsolidar: true,
            modoConsolidar: null,
            idLote: null,
            width: '50%',
            dadosCadastroPSSC: {
                idLote: null,
                selecionarTodos: null,
                selecao: null
            }
        };
    },

    watch: {
        show: {
            handler() {
                this.show_ = this.show;
                this.dadosCadastroPSSC.selecionarTodos = this.selecionarTodos;
                this.dadosCadastroPSSC.selecao = this.selecao;
                this.width = '50%';
                if (this.show) {
                    this.buscarLotes()
                    .then(() => {
                        this.checarLotesExistentes();
                    });
                }
            },
            immediate: true
        }
    },

    methods: {
        closeDialog() {
            this.show_ = false;
            this.dadosCadastroPSSC.idLote = null;
            this.$emit('closeDialog');
        },
        async processarNovoLote() {
            if (this.modoConsolidar === 'ESCOLHER_LOTE') {
                this.dadosCadastroPSSC.idLote = this.idLote;
                await this.consolidarLote();
            } else if (this.modoConsolidar === 'NOVO_LOTE') {
                await PSSCService.inserirLote({'nome': this.nomeNovoLote_})
                    .then(({data}) => {
                        this.dadosCadastroPSSC.idLote = data.id;
                        this.consolidarLote();
                    })
                    .catch((error) => {
                        if (error.response.data.message === 'LOTE_EXISTENTE') {
                            this.mostrarMensagemErroLote = true;
                            document.getElementsByClassName('el-input_lote')[0].classList.add('campo-obrigatorio');
                        } else {
                            this.$notify.error({
                                message: this.$t('mensagens.pssc.telaIncluirTerritorios.erroInserirLote')
                            });
                        }
                    })
                    .finally(() => {
                        setTimeout(() => {
                            document.getElementsByClassName('el-input_lote')[0].classList.remove('campo-obrigatorio');
                            this.mostrarMensagemErroLote = false;
                        }, 5000);
                    });
            }
        },
        habilitarConsolidarLote() {
            if (this.modoSelecaoLote === 'ESCOLHER_LOTE') {
                this.habilitarBotaoConsolidar((this.lote && this.lote !== ''), null, this.modoSelecaoLote, this.lote);
            } else {
                this.habilitarBotaoConsolidar((this.nomeNovoLote && this.nomeNovoLote !== ''), this.nomeNovoLote, this.modoSelecaoLote, null);
            }
        },
        alterarMetodoConsolidacao() {
            this.lote = null;
            this.nomeNovoLote = null;
            this.habilitarConsolidarLote();
        },
        checarLotesExistentes() {
            if (this.opcoesLotes) {
                this.modoSelecaoLote = 'ESCOLHER_LOTE';
            }
        },
        async buscarLotes() {
            try {
                const { data } = await PSSCService.buscarLotes();
                if (data.itens.length > 0) {
                    this.opcoesLotes = data.itens;
                }
            } catch {
                this.$notify.error({
                    message: 'Não foi possível buscar os lotes.'
                });
            }
        },

        consolidarLote() {
            try {
                PSSCService.consolidarLote({
                    ...this.filtros,
                    ...this.dadosCadastroPSSC
                });
                this.closeDialog();
                this.$emit('showNotificacaoSucesso');
            } catch (err) {
                this.$notify.error({
                    message: this.$t('mensagens.pssc.telaIncluirTerritorios.erroConsolidarLote')
                });
            }
        },
        habilitarBotaoConsolidar(statusBotao, nomeNovoLote, modo, idLote) {
            this.habilitarConsolidar = !statusBotao;
            this.modoConsolidar = modo;
            this.idLote = idLote;

            if (nomeNovoLote) this.nomeNovoLote_ = nomeNovoLote;
        }
    }
};
</script>

<style lang="scss">
#modal-consolidar-lote-pssc {

    .modal-sucesso-content{
        height: fit-content;
    }
    .modal-selecao-sucesso-container {
        display: flex;
        justify-content: space-between;
        width: 100%;
        height: fit-content;
        border: 1px solid #C0DDC1;
        border-radius: 4px;
        background-color: #EBF4EB;
        padding: 0 14px;
        margin-top: 3px !important;
        .icon-success-filled-verde {
            color: #359138 !important;
            width: 17px;
            height: fit-content;
            padding: 17px 0;
        }
        .sucesso-selecao-descricao {
            text-align: justify;
            height: fit-content;
            width: 96%;
            font-size: 14px;
            margin: 0px;
            padding: 14px 0;
        }
    }
    .modal-lote-container {
        width: 100%;
        height: fit-content;
        padding: 25px 0;
        font-size: 14px;
        .modal-selecao-lote {
            display: flex;
            flex-direction: column;
            .selecao-lote {
                padding: 10px 0 0 0;
                font-weight: normal !important;
            }

            .selecao-lote.is-checked {
                .el-radio__label {
                    color: var(--secondary-two) !important;
                }
            }
        }
    }

    .modal-escolha-lote {
        min-height: 100px;
        .el-select_lote {
            width: 100%;
            padding: 0;
            margin-top: 10px;
        }
    }
    .modal-novo-lote {
        min-height: 100px;
        .el-input_lote{
            width: 100%;
            padding: 0;
            margin-top: 10px;
        }
    }

    .cadastro-campo-erro {
        color: #DC362E;
        font-size: 12px;
        padding: 5px 0;
    }
    .modal-texto-bold {
        font-weight: 500;
    }

    .el-dialog__footer {
        margin-top: 0;
        text-align: right;
        border-top: solid 2px #e7e7e7;
        background-color: #ffffff;

        .dialog-footer {
            display: flex;
            justify-content: flex-end;
            gap: 16px;
        }
    }

    .el-dialog__close {
        color: #3B3B3B;
        &:before {
            font-size: 20px;
            font-weight: 600;
        }
    }

    .outline-button {
        margin: 0px !important;
    }

    .primary-button {
        margin: 0px !important;
    }

    .modal-text {
        font-family: 'Roboto', 'sans serif';
        font-size: 14px;
        font-weight: 500;
        line-height: 16px;
        letter-spacing: 0em;
        text-align: left;
        padding-bottom: 8px;
    }

    .el-dialog__body {
        max-height: 525px;
        overflow-y: auto;
    }

    .el-dialog__body {
        padding: 20px;
        background-color: #ffffff;
        padding-bottom: 0;
        span {
            color: #3b3b3b;
        }
    }

    .el-dialog__header {
        padding: 15px 20px !important;
        background-color: #e9e9e9;
        .el-dialog__title {
            color: #00413c;
            font-weight: 600;
            font-size: 18px;
            line-height: 22px;
        }
    }

    .el-dialog__body {
        max-height: 525px;
        padding: 15px;
    }

    .font-bold {
        font-weight: 600;
    }

    .el-divider--horizontal {
        margin: 15px 0 8px 0;
    }
}
</style>
